<template>
    <div class="table_wrap">
        <div class="filter_wrap">
<!--          <div class="filter_row">-->
<!--                <div class="filter_content">-->
<!--                    <div class="filter_titleBox mr15">-->
<!--                        <span class="filter_title">결제 방식</span>-->
<!--                    </div>-->
<!--                    <div class="filter">-->
<!--&lt;!&ndash;                        #todo 추후 결제 방식에 대한 기능 추가가 필요합니다.&ndash;&gt;-->
<!--                        <el-select v-model="filterPayment" @change="setFilterFunc('', filterPayment)">-->
<!--                            <el-option :label="'전체'" :value="''"></el-option>-->
<!--                            <el-option :label="'무통장'" :value="1"></el-option>-->
<!--                            <el-option :label="'카드'" :value="10"></el-option>-->
<!--                            <el-option :label="'가상계좌'" :value="11"></el-option>-->
<!--                            <el-option :label="'실시간계좌이체'" :value="12"></el-option>-->
<!--                            <el-option :label="'휴대폰결제'" :value="13"></el-option>-->
<!--                            <el-option :label="'네이버페이'" :value="30"></el-option>-->
<!--                            <el-option :label="'카카오페이'" :value="31"></el-option>-->
<!--                            <el-option :label="'페이팔'" :value="32"></el-option>-->
<!--                        </el-select>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
            <div class="filter_row">
                <div class="filter_content">
                    <div class="filter_titleBox mr15">
                        <span class="filter_title">신청일시</span>
                    </div>
                    <div class="filter">
                        <el-date-picker
                            class="datePicker_long"
                            v-model="filterApplyDate"
                            type="daterange"
                            value-format="yyyy-MM-dd"
                            @change="setFilterFunc('ap', filterApplyDate)"
                            start-placeholder="시작일"
                            end-placeholder="종료일"
                            :editable="false"
                        >
                        </el-date-picker>
                    </div>
                </div>
            </div>
            <div class="filter_row">
                <div class="filter_content">
                    <div class="filter_titleBox mr15">
                        <span class="filter_title">검색 구분</span>
                    </div>
                    <div class="filter mr10">
                        <el-select class="el-select" v-model="searchInputOption">
                            <el-option value="mbid" :label="'아이디'"></el-option>
                            <el-option value="ni" :label="'닉네임'"></el-option>
                            <el-option value="de" :label="'입금금액'"></el-option>
                        </el-select>
                    </div>
                    <div class="filter">
                        <el-input v-model="searchInput" @keypress.enter.native="setFilterFunc(searchInputOption, searchInput)" placeholder="검색어를 입력해 주세요." class="littleShort mr10"></el-input>
                        <el-button class="com_search"  @click="setFilterFunc(searchInputOption, searchInput)">
                            검색
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="filter-show-count mt15 mb15">
            <el-select class="veryShort" v-model="size" @change="changePage('size', size)">
                <el-option v-for="(sizeData) in sizeList" :key="`size${sizeData}`" :value="sizeData"
                           :label="`${sizeData}개씩 보기`"></el-option>
            </el-select>
        </div>
    </div>
</template>

<script>
import pointUtil from "@/components/point/pointUtil";
import util from "@/mixins/util";
import {pointStatus} from "@/service/pointService";
const {filterConfig} = pointUtil;

export default {
    name: "PointFilterDepositLayout",
    mixins: [],
    components: {},
    inject: ['setPage', 'setFilter'],
    provide() {
        return {}
    },
    props: {
        filterData: {default: () => {}},
        paginationData: {default: {total: 0, page: 0, size: 0,}},
    },
    data() {
        return {
            filterApplyDate: '',
            searchInputOption: 'mbid',
            searchInput: '',
            filterPointStatus : '',
            filterDepositStatus: '',
            filterPayment: '',
            pointStatus: pointStatus,
            size: 10,
            sizeList: [10, 30, 50],
        }
    },
    created() {
    },
    mounted() {
        this.setterFilterDataInData();
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setterFilterDataInData() {
            let classnames = Object.keys(this.filterData);
            classnames.forEach(classname => {
                let obj = this.filterData[classname];
                let type = filterConfig[obj.key].type;
                if (this.hasOwnProperty(classname)) {
                    if (type == 'query') {
                        this[classname] = obj.query;
                        if (this.hasOwnProperty(classname + 'Option')) {
                            this[classname + 'Option'] = obj.key;
                        }
                    } else if (type === 'between') {
                        this[classname] = [obj.start, obj.end];
                    } else if (type === 'match') {
                        let arr = obj.value.split(',');
                        if (arr.length > 1) {
                            let numArr = []
                            for (let i of arr) {
                                numArr.push(Number(i))
                            };
                            this[classname] = numArr
                        } else if (isNaN(obj.value)) {
                            this[classname] = obj.value;
                        } else {
                            this[classname] = Number(obj.value);
                        }

                    }else if(type === 'terms') {
                        if(isNaN(obj.terms[0])) {
                            this[classname] = obj.terms[0];
                        }else{
                            this[classname] = Number(obj.terms[0]);
                        }

                    }

                }
            })
            this.size = this.paginationData.size;
        },

        // 데이터가 1개이지만 array형식으로 보내야 할 때 사용
        setFilterArrayFunc(key, value) {
            let arr = []
            if (!util.isEmpty(value)) {
                arr.push(value)
            }
            this.setFilter(key, arr);
        },
        setFilterFunc(key, value) {
            this.setFilter(key, value);
        },
        changePage(key, value) {
            this.setPage(key, value);
            this.setPage('page', 1);
        },
        checkFilterData() {
            return this.filterDate != null && this.filterDate.length > 0;
        },
    },
    watch: {},
}
</script>

<style lang="scss">


</style>
